import { render, staticRenderFns } from "./SMSmarketing.vue?vue&type=template&id=062016c3&scoped=true"
import script from "./SMSmarketing.vue?vue&type=script&lang=js"
export * from "./SMSmarketing.vue?vue&type=script&lang=js"
import style0 from "./SMSmarketing.vue?vue&type=style&index=0&id=062016c3&prod&lang=css"
import style1 from "./SMSmarketing.vue?vue&type=style&index=1&id=062016c3&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062016c3",
  null
  
)

export default component.exports